"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RainOfScimitarsAbilityHandler = exports.RainOfScimitarsActorAbilityFactory = exports.RainOfScimitarsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class RainOfScimitarsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RainOfScimitars;
        this.__typeName = "RainOfScimitars";
    }
}
exports.RainOfScimitarsAbilityArgs = RainOfScimitarsAbilityArgs;
let RainOfScimitarsActorAbilityFactory = class RainOfScimitarsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RainOfScimitars", "AllEnemies", 2);
    }
};
RainOfScimitarsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RainOfScimitars")
], RainOfScimitarsActorAbilityFactory);
exports.RainOfScimitarsActorAbilityFactory = RainOfScimitarsActorAbilityFactory;
let RainOfScimitarsAbilityHandler = class RainOfScimitarsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Physical", 35),
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 35),
                ],
                effects: [
                    (0, Random_1.randomPercent)() <= 50 && new core_1.BleedingEffectArgs("Focus", 10)
                ].filter(Boolean)
                    .map(effect => ({
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect,
                }))
            })),
            onHit: (sequence, target) => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "RainOfScimitars"));
            },
            onMiss: (sequence, target) => {
                sequence.push(new core_2.InstantVfxStepArgs(LocationSelector_1.ActorVfxLocationSelector.Miss(target.targetId), "RainOfScimitars"));
            },
        });
    }
};
RainOfScimitarsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RainOfScimitars)
], RainOfScimitarsAbilityHandler);
exports.RainOfScimitarsAbilityHandler = RainOfScimitarsAbilityHandler;
